export default __webpack_public_path__ + "static/Plots0004-8b8e79214570b4c5c7af85839f7eb064.jpg";